/**
 * Inject Mermaid auto-render into a full HTML slide document (for iframe srcdoc).
 * Keeps original CSS/JS; adds CDN Mermaid + scan of <pre>/<code> / .mermaid.
 */

const MERMAID_CDN = 'https://cdn.jsdelivr.net/npm/mermaid@11.6.0/dist/mermaid.min.js'

/** Vanilla JS bootstrapped inside slide iframe (no React). */
function buildMermaidBootScript(): string {
  // Built with RegExp + string concat so we avoid nested template escape bugs.
  const lines = [
    '(function () {',
    '  var MERMAID_START = new RegExp(',
    '    "^(sequenceDiagram|flowchart|graph\\\\s|classDiagram|stateDiagram|erDiagram|journey|gantt|pie|mindmap|timeline|quadrantChart|sankey|xychart|requirementDiagram|C4Context)\\\\b",',
    '    "m"',
    '  );',
    '  var FENCE = new RegExp("^```(?:mermaid)?\\\\s*\\\\r?\\\\n?([\\\\s\\\\S]*?)```$", "i");',
    '',
    '  function normalize(raw) {',
    '    var t = String(raw || "").trim();',
    '    var m = FENCE.exec(t);',
    '    if (m) t = m[1].trim();',
    '    return t;',
    '  }',
    '',
    '  // Escape & in labels; graph→flowchart; un-glue :::class stuck to next node id.',
    '  function sanitize(raw) {',
    '    var t = String(raw || "").replace(/^(graph)(\\s+)/im, "flowchart$2");',
    '    t = t.replace(/(:::[A-Za-z_][\\w-]*)(?=[A-Z][A-Za-z0-9_]*\\s*[\\[\\(\\{])/g, "$1\\n");',
    '    t = t.replace(/(;)\\s*(?=[A-Z][A-Za-z0-9_]*\\s*[\\[\\(\\{])/g, "$1\\n");',
    '    return t.replace(/\\|([^|]*)\\|/g, function (_m, label) {',
    '      return "|" + String(label).replace(/&/g, "#amp;") + "|";',
    '    });',
    '  }',
    '',
    '  function textOf(el) {',
    '    if (!el) return "";',
    '    // innerText keeps <br> as newlines; textContent drops them (Quill glue bug)',
    '    return String(el.innerText || el.textContent || "").replace(/\\u00a0/g, " ").trim();',
    '  }',
    '',
    '  function looksLike(code, lang) {',
    '    if (lang === "mermaid") return true;',
    '    return MERMAID_START.test(normalize(code));',
    '  }',
    '',
    '  function extractLang(el) {',
    '    if (!el) return undefined;',
    '    var cls = el.className || "";',
    '    var m = /(?:^|\\s)language-(\\w+)/.exec(cls);',
    '    if (m) return m[1].toLowerCase();',
    '    var d = el.getAttribute("data-language") || el.getAttribute("data-lang");',
    '    return d ? String(d).toLowerCase() : undefined;',
    '  }',
    '',
    '  function loadMermaid() {',
    '    return new Promise(function (resolve, reject) {',
    '      if (window.mermaid) { resolve(window.mermaid); return; }',
    '      var existing = document.querySelector("script[data-slide-mmd-cdn]");',
    '      if (existing) {',
    '        existing.addEventListener("load", function () {',
    '          if (window.mermaid) resolve(window.mermaid);',
    '          else reject(new Error("Mermaid không khởi tạo được"));',
    '        });',
    '        existing.addEventListener("error", function () { reject(new Error("Tải Mermaid thất bại")); });',
    '        return;',
    '      }',
    `      var s = document.createElement("script");`,
    `      s.src = ${JSON.stringify(MERMAID_CDN)};`,
    '      s.async = true;',
    '      s.setAttribute("data-slide-mmd-cdn", "1");',
    '      s.onload = function () {',
    '        if (window.mermaid) resolve(window.mermaid);',
    '        else reject(new Error("Mermaid không khởi tạo được"));',
    '      };',
    '      s.onerror = function () { reject(new Error("Tải Mermaid thất bại")); };',
    '      document.head.appendChild(s);',
    '    });',
    '  }',
    '',
    '  async function run() {',
    '    var api = await loadMermaid();',
    '    api.initialize({',
    '      startOnLoad: false,',
    '      securityLevel: "loose",',
    '      theme: "base",',
    '      flowchart: { htmlLabels: false, useMaxWidth: true, nodeSpacing: 40, rankSpacing: 50, padding: 12 },',
    '      themeVariables: {',
    '        darkMode: false,',
    '        background: "#ffffff",',
    '        primaryColor: "#e8f5e9",',
    '        primaryTextColor: "#0f172a",',
    '        primaryBorderColor: "#0f3e17",',
    '        secondaryColor: "#f1f5f9",',
    '        secondaryTextColor: "#0f172a",',
    '        tertiaryColor: "#ffffff",',
    '        tertiaryTextColor: "#0f172a",',
    '        lineColor: "#334155",',
    '        textColor: "#0f172a",',
    '        mainBkg: "#ffffff",',
    '        nodeBorder: "#0f3e17",',
    '        clusterBkg: "#f8fafc",',
    '        titleColor: "#0f172a",',
    '        edgeLabelBackground: "#ffffff",',
    '        actorBkg: "#e8f5e9",',
    '        actorBorder: "#0f3e17",',
    '        actorTextColor: "#0f172a",',
    '        signalColor: "#334155",',
    '        signalTextColor: "#0f172a",',
    '        labelTextColor: "#0f172a",',
    '        loopTextColor: "#0f172a",',
    '        noteBkgColor: "#fffbeb",',
    '        noteTextColor: "#0f172a",',
    '        sequenceNumberColor: "#0f172a"',
    '      }',
    '    });',
    '    var hosts = [];',
    '    var seen = new Set();',
    '',
    '    document.querySelectorAll("pre").forEach(function (pre) {',
    '      var codeEl = pre.querySelector("code");',
    '      var text = textOf(codeEl || pre);',
    '      var lang = extractLang(codeEl || pre);',
    '      if (!looksLike(text, lang) || seen.has(pre)) return;',
    '      seen.add(pre);',
    '      hosts.push({ el: pre, code: text });',
    '    });',
    '',
    '    document.querySelectorAll("code.language-mermaid").forEach(function (codeEl) {',
    '      if (codeEl.closest("pre")) return;',
    '      var text = textOf(codeEl);',
    '      if (!looksLike(text, "mermaid") || seen.has(codeEl)) return;',
    '      seen.add(codeEl);',
    '      hosts.push({ el: codeEl, code: text });',
    '    });',
    '',
    '    // Standard Mermaid host: <div class="mermaid">…</div> (e.g. slide decks)',
    '    document.querySelectorAll(".mermaid").forEach(function (el) {',
    '      if (seen.has(el)) return;',
    '      if (el.classList && el.classList.contains("m2-mermaid-slide")) return;',
    '      if (el.querySelector && el.querySelector("svg")) return;',
    '      if (el.closest && (el.closest("pre") || el.closest("code"))) return;',
    '      var text = textOf(el);',
    '      if (!text || !looksLike(text, "mermaid") || seen.has(el)) return;',
    '      seen.add(el);',
    '      hosts.push({ el: el, code: text });',
    '    });',
    '',
    '    for (var i = 0; i < hosts.length; i++) {',
    '      var item = hosts[i];',
    '      var source = sanitize(normalize(item.code));',
    '      try {',
    '        var result = await api.render("slide-mmd-" + i + "-" + Date.now(), source);',
        '        var wrap = document.createElement("div");',
        '        wrap.className = "m2-mermaid-slide";',
        '        wrap.style.cssText = "margin:12px 0;padding:12px;overflow-x:auto;text-align:center;background:#ffffff;color:#0f172a;border:1px solid #e2e8f0;border-radius:8px;";',
        '        wrap.innerHTML = result.svg;',
        '        wrap.querySelectorAll("rect.actor, rect.actor-top, rect.actor-bottom, rect.actor-man").forEach(function (el) {',
        '          el.setAttribute("fill", "#e8f5e9");',
        '          el.setAttribute("stroke", "#0f3e17");',
        '        });',
        '        wrap.querySelectorAll("text, text.actor, tspan").forEach(function (t) {',
        '          t.setAttribute("fill", "#0f172a");',
        '          var style = t.getAttribute("style") || "";',
        '          if (/fill\\s*:/i.test(style)) {',
        '            t.setAttribute("style", style.replace(/fill\\s*:\\s*[^;]+/ig, "fill:#0f172a"));',
        '          }',
        '        });',
        '        wrap.querySelectorAll("foreignObject, foreignObject *").forEach(function (el) {',
        '          if (el.style) el.style.color = "#0f172a";',
        '        });',
        '        item.el.replaceWith(wrap);',
    '      } catch (err) {',
    '        var errBox = document.createElement("div");',
    '        errBox.style.cssText = "margin:8px 0;padding:8px;border:1px solid #fecaca;background:#fef2f2;color:#991b1b;font-size:12px;";',
    '        errBox.textContent = "Mermaid: " + ((err && err.message) || "không render được sơ đồ");',
    '        if (item.el.parentNode) item.el.parentNode.insertBefore(errBox, item.el);',
    '      }',
    '    }',
    '  }',
    '',
    '  if (document.readyState === "loading") {',
    '    document.addEventListener("DOMContentLoaded", function () { run().catch(console.error); });',
    '  } else {',
    '    run().catch(console.error);',
    '  }',
    '})();',
  ]
  return lines.join('\n')
}

/** Resolve absolute URL for a material file path. */
export function resolveMaterialAbsoluteUrl(fileUrl: string): string {
  if (/^https?:\/\//i.test(fileUrl)) return fileUrl
  const path = fileUrl.startsWith('/') ? fileUrl : `/${fileUrl}`
  return `${window.location.origin}${path}`
}

/** Directory URL ending with / for <base href>. */
export function materialBaseHref(fileUrl: string): string {
  const abs = resolveMaterialAbsoluteUrl(fileUrl)
  const q = abs.indexOf('?')
  const clean = q >= 0 ? abs.slice(0, q) : abs
  const lastSlash = clean.lastIndexOf('/')
  return lastSlash >= 0 ? clean.slice(0, lastSlash + 1) : `${clean}/`
}

function ensureBaseTag(html: string, baseHref: string): string {
  if (/<base\s/i.test(html)) return html
  const tag = `<base href="${baseHref.replace(/"/g, '&quot;')}">`
  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head([^>]*)>/i, `<head$1>${tag}`)
  }
  if (/<html[^>]*>/i.test(html)) {
    return html.replace(/<html([^>]*)>/i, `<html$1><head>${tag}</head>`)
  }
  return `${tag}${html}`
}

function appendBeforeCloseBody(html: string, snippet: string): string {
  if (/<\/body>/i.test(html)) {
    return html.replace(/<\/body>/i, `${snippet}</body>`)
  }
  return `${html}${snippet}`
}

const MERMAID_SLIDE_CSS = `
<style data-m2-mermaid>
  /* Undo host/Tailwind svg sizing so Mermaid layout measures correctly */
  .mermaid svg,
  svg[id^="mermaid-"],
  svg[aria-roledescription] {
    max-width: none !important;
    height: auto !important;
  }
  /* Mermaid diagrams — light canvas, dark text */
  .m2-mermaid-slide { color: #0f172a !important; background: #ffffff !important; }
  .m2-mermaid-slide svg { max-width: 100%; height: auto; }
  .m2-mermaid-slide text,
  .m2-mermaid-slide text.actor,
  .m2-mermaid-slide tspan,
  .m2-mermaid-slide .messageText,
  .m2-mermaid-slide .label,
  .m2-mermaid-slide .nodeLabel,
  .m2-mermaid-slide .edgeLabel,
  .m2-mermaid-slide .loopText,
  .m2-mermaid-slide .noteText { fill: #0f172a !important; color: #0f172a !important; }
  .m2-mermaid-slide foreignObject,
  .m2-mermaid-slide foreignObject div,
  .m2-mermaid-slide foreignObject span { color: #0f172a !important; }
  .m2-mermaid-slide rect.actor,
  .m2-mermaid-slide rect.actor-top,
  .m2-mermaid-slide rect.actor-bottom,
  .m2-mermaid-slide rect.actor-man { fill: #e8f5e9 !important; stroke: #0f3e17 !important; }

  /* Scope light theme to mermaid *source* only — never all <pre> (dark code demos). */
  code.language-mermaid,
  pre.language-mermaid,
  pre:has(> code.language-mermaid),
  pre:has(code.language-mermaid) {
    color: #0f172a !important;
    background: #f8fafc !important;
  }

  /* Force dark high-contrast code cards (slide demo windows) */
  .code-card,
  .code-card .code-body,
  .code-card pre.code-body,
  pre.code-body {
    background-color: #0d1117 !important;
  }
  .code-card pre code,
  pre.code-body code {
    background: transparent !important;
    color: #e6edf3 !important;
  }
  .code-card .code-kw,
  pre.code-body .code-kw { color: #ff7b72 !important; }
  .code-card .code-str,
  pre.code-body .code-str { color: #79c0ff !important; }
  .code-card .code-fn,
  pre.code-body .code-fn { color: #d2a8ff !important; }
  .code-card .code-cm,
  pre.code-body .code-cm { color: #8b949e !important; }
  .code-card .code-accent,
  pre.code-body .code-accent { color: #fbbf24 !important; font-weight: 700; }
  .code-card .code-tab {
    color: rgba(255, 255, 255, 0.72) !important;
  }
</style>
`

/**
 * Prepare HTML slide content for iframe srcdoc: base href + Mermaid auto-render.
 */
export function prepareHtmlSlideWithMermaid(html: string, fileUrl: string): string {
  const withBase = ensureBaseTag(html, materialBaseHref(fileUrl))
  const inject = `${MERMAID_SLIDE_CSS}<script>${buildMermaidBootScript()}</script>`
  return appendBeforeCloseBody(withBase, inject)
}
